/**
 * Venn — two overlapping circles, the Kompatibilität (compatibility) agent
 * glyph. lucide-react has no Venn/intersection icon, so this is a hand-drawn
 * SVG that matches the lucide visual grammar (24×24 viewBox, fill:none,
 * stroke:currentColor, strokeWidth 2, round caps/joins) so it sits cleanly
 * beside the other agent icons in the identity registry.
 *
 * Renders like a lucide icon: size via Tailwind h- / w- classes (CSS wins
 * over the width/height attributes), colour via text- utilities (currentColor).
 */
import type { SVGProps } from 'react'

export function Venn({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <circle cx="9" cy="12" r="6" />
      <circle cx="15" cy="12" r="6" />
    </svg>
  )
}
